// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateFacetFilterText = (state, action) => action.text;

export default (state = getDefaultState().facetFilterText, action) => {

    const actionTypes = {
        [actions.UPDATE_TCSM_AUDIT_FACET_FILTER_TEXT]: updateFacetFilterText
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/audits/reducers/facet-filter-text.js